import api from ".";

const skuPath = "/api/sku";

export const createRecipeSku = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/recipe-builder`, payload);
    return data;
  } catch (error) {
    console.error("Create Recipe SKU API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || error;
  }
};

export const createPrivateLabelSku = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/private-label`, payload);
    return data;
  } catch (error) {
    console.error("Create Private Label SKU API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || error;
  }
};

export const saveRecipeToDatabase = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/save-recipe`, payload);
    return data;
  } catch (error) {
    console.error("Save Recipe API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || { message: "Failed to save recipe" };
  }
};

export const syncRecipeToErpag = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/sync-to-erpag`, payload);
    return data;
  } catch (error) {
    console.error("Sync Recipe to ERPAG Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || { message: error.message || "Failed to sync recipe to ERPAG" };
  }
};

export const createFormatSku = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/format-builder`, payload);
    return data;
  } catch (error) {
    console.error("Create Format SKU API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || { message: "Failed to create format SKU" };
  }
};

export const getSkuBySku = async (sku) => {
  if (!sku || typeof sku !== "string" || sku.trim() === "") {
    throw new Error("Valid SKU is required");
  }

  try {
    const { data } = await api.get(
      `${skuPath}/${encodeURIComponent(sku.trim())}`,
    );
    return data;
  } catch (error) {
    console.error(`Get SKU "${sku}" API Error:`, {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error.response?.data || { message: `SKU ${sku} not found` };
  }
};

export const getSystemGeneratedUPCs = async () => {
  try {
    const { data } = await api.get(`${skuPath}/upc/all`);
    return data;
  } catch (error) {
    console.error("clearCostingBatch error:", error);
    throw error.response?.data || { message: "Failed to clear costing batch" };
  }
};

export const generateUniqueUpc = async (prefix = "693997") => {
  try {
    const { data } = await api.post(`${skuPath}/generate-upc`, { prefix });
    return data;
  } catch (error) {
    console.error("Generate unique UPC failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to generate UPC",
      }
    );
  }
};

export const generateBulkBarcodes = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/barcode-tool/generate`, payload);
    return data;
  } catch (error) {
    console.error("Generate bulk barcodes failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to generate bulk barcodes",
      }
    );
  }
};

export const saveBulkBarcodes = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/barcode-tool/save`, payload);
    return data;
  } catch (error) {
    console.error("Save bulk barcodes failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to save bulk barcodes",
      }
    );
  }
};

export const getCostingDraft = async () => {
  try {
    const { data } = await api.get(`${skuPath}/costing-draft`);
    return data;
  } catch (error) {
    console.error("Get costing draft failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to fetch costing draft",
      }
    );
  }
};

export const saveCostingDraft = async (payload) => {
  try {
    const { data } = await api.post(`${skuPath}/costing-draft`, payload);
    return data;
  } catch (error) {
    console.error("Save costing draft failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to save costing draft",
      }
    );
  }
};

export const deleteCostingDraft = async () => {
  try {
    const { data } = await api.delete(`${skuPath}/costing-draft`);
    return data;
  } catch (error) {
    console.error("Delete costing draft failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to delete costing draft",
      }
    );
  }
};

export const getCostingBatch = async () => {
  try {
    const { data } = await api.get(`${skuPath}/costing-batch`);
    return data;
  } catch (error) {
    console.error("Get costing batch failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to fetch costing batch",
      }
    );
  }
};

export const upsertCostingBatchItem = async (payload) => {
  try {
    const { data } = await api.put(`${skuPath}/costing-batch/item`, payload);
    return data;
  } catch (error) {
    console.error("Upsert costing batch item failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to save costing batch item",
      }
    );
  }
};

export const deleteCostingBatchItem = async (skuKey) => {
  try {
    const { data } = await api.delete(
      `${skuPath}/costing-batch/item/${encodeURIComponent(String(skuKey || "").trim())}`,
    );
    return data;
  } catch (error) {
    console.error("Delete costing batch item failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to delete costing batch item",
      }
    );
  }
};

export const clearCostingBatch = async () => {
  try {
    const { data } = await api.delete(`${skuPath}/costing-batch`);
    return data;
  } catch (error) {
    console.error("Clear costing batch failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to clear costing batch",
      }
    );
  }
};

export const getPriceManagementSkus = async (params) => {
  try {
    const { filter = "", search = "", categories = "", page = 1, limit = 100, sortBy = "sku", sortOrder = "asc", skuFilter = "", nameFilter = "", hiddenCategories = "", segment = "" } = params || {};
    const query = new URLSearchParams();
    if (filter) query.append("filter", filter);
    if (search) query.append("search", search);
    if (categories) query.append("categories", categories);
    if (hiddenCategories) query.append("hiddenCategories", hiddenCategories);
    if (segment) query.append("segment", segment);
    if (sortBy) query.append("sortBy", sortBy);
    if (sortOrder) query.append("sortOrder", sortOrder);
    if (skuFilter) query.append("skuFilter", skuFilter);
    if (nameFilter) query.append("nameFilter", nameFilter);
    query.append("page", page);
    query.append("limit", limit);
    
    const { data } = await api.get(`${skuPath}/price-management?${query.toString()}`);
    return data;
  } catch (error) {
    console.error("Get Price Management SKUs Error:", error);
    throw error.response?.data || { message: "Failed to fetch SKUs" };
  }
};

export const bulkUpdatePriceManagementSkus = async (updates) => {
  try {
    const { data } = await api.post(`${skuPath}/price-management/bulk-update`, { updates });
    return data;
  } catch (error) {
    console.error("Bulk Update Price Management Error:", error);
    throw error.response?.data || { message: "Failed to bulk update SKUs" };
  }
};

export const getSkuRawSnapshot = async (sku) => {
  try {
    const { data } = await api.get(`${skuPath}/price-management/${sku}/snapshot`);
    return data;
  } catch (error) {
    console.error("Get SKU Raw Snapshot Error:", error);
    throw error.response?.data || { message: "Failed to fetch SKU snapshot" };
  }
};

export const deleteRecipeSku = async (sku) => {
  try {
    const { data } = await api.delete(`${skuPath}/recipe/${encodeURIComponent(sku)}`);
    return data;
  } catch (error) {
    console.error("Delete Recipe SKU API Error:", error);
    throw error.response?.data || { message: error.message || "Failed to delete SKU" };
  }
};
